module.exports = __webpack_public_path__ + "images/application/i-failed-fb5249a5.svg";